import styled from '@emotion/styled';
import { InputAdornment, TextField } from '@mui/material';
import Icons from '@shared/components/core/images/Icons';
import { color } from '@shared/constants/Styles';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface SearchFieldProps {
    label?: string;
    value: string;
    placeholder?: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onClear: () => void;
}

function SearchField({ label, placeholder = '', value = '', onChange, onClear }: SearchFieldProps) {
    const { t } = useTranslation();
    label = label || t('common:search');
    return (
        <>
            <StyledTextField
                onChange={onChange}
                size="small"
                fullWidth
                variant="outlined"
                placeholder={placeholder}
                label={label}
                value={value}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <Icons name="search" color={color.tertiary} />
                            </InputAdornment>
                        ),
                        endAdornment: (
                            <InputAdornment position="end">
                                {value && (
                                    <CloseButton onClick={onClear}>
                                        <Icons name="cancel2" ariaLabel={t('common:close')} />
                                    </CloseButton>
                                )}
                            </InputAdornment>
                        ),
                    },
                }}
            />
        </>
    );
}

const StyledTextField = styled(TextField)`
    margin: 1rem 0;
    background: ${(props) => props.theme.color.background};
    input {
        &:focus {
            outline: none;
        }
    }
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    color: ${(props) => props.theme.color.text};
`;

export default SearchField;
